export function character_url(character_id: number, size: number) {
    return `https://images.evetech.net/characters/${character_id}/portrait?size=${size}`;
}
